import { ConsentProviderInterface } from "./consent-provider-interface";
import { inject, singleton } from "tsyringe";
import { Consents } from "../types";
import { WINDOW } from "@identity/symbols";

@singleton()
export class UspApi implements ConsentProviderInterface {
  consentGiven: Promise<Consents>;
  private resolveConsent: (consent: Consents) => void;
  private USP_API_VERSION = 1;
  private CCPA_TRACKING_ALLOWED = "1YN";
  private queue = [];

  constructor(@inject(WINDOW) private window: Window) {
    // this.installUspApi();
    // ToDo: Fix CCPA Consent query. Currently it is not needed, as we do handle that query in TrackingOptIn on
    //  Fandom Pages and via OneTrust on N&R pages
    this.consentGiven = new Promise((res) => (this.resolveConsent = res));
    // this.readTrackingConsents();
    // this.subscribe();
  }

  installUspApi(): void {
    this.window.__uspapi = this.uspApiMessage.bind(this);

    this.addLocatorFrame();
    this.addUspMessageListener();
  }

  consentsUpdated(consent): void {
    this.resolveConsent({
      gdprConsent: true,
      geoRequiresConsent: false,
      geoRequiresSignal: true,
      ccpaSignal: !consent.startsWith(this.CCPA_TRACKING_ALLOWED),
    });
  }

  private uspApiMessage(commandName, version, callback) {
    if (commandName === "ping") {
      callback({ uspapiLoaded: false }, true);
    } else if (commandName === "getQueue") {
      callback(this.queue, true);
    } else {
      this.queue.push([commandName, version, callback]);
    }
  }

  private addLocatorFrame(): void {
    const name = "__uspapi";

    if (this.window.frames[name]) {
      return;
    }

    if (document.readyState === "loading") {
      document.addEventListener("DOMContentLoaded", () =>
        this.addLocatorFrame(),
      );
      return;
    }

    const iframe = document.createElement("iframe");

    iframe.name = name;
    iframe.style.display = "none";
    document.body.appendChild(iframe);
  }

  private addUspMessageListener(): void {
    this.window.addEventListener(
      "message",
      (event) => {
        const call = this.convertUspMessageData(event);
        if (call) {
          this.uspMessageHandler(call, event);
        }
      },
      false,
    );
  }

  private convertUspMessageData(event): unknown {
    try {
      const data =
        typeof event.data === "string" ? JSON.parse(event.data) : event.data;
      return data.__uspapiCall;
    } catch (error) {
      void error;
    }
  }

  private uspMessageHandler(call, event): void {
    this.window.__uspapi(call.command, call.version, (returnValue, success) => {
      const returnMsg = {
        __uspapiReturn: {
          returnValue,
          success,
          callId: call.callId,
        },
      };
      event.source.postMessage(returnMsg, "*");
    });
  }

  // @ts-expect-error uspApi is currently not available in IE as it needs to be fixed
  private subscribe(): void {
    this.window.__uspapi &&
      this.window.__uspapi(
        "addEventListener",
        this.USP_API_VERSION,
        this.consentsUpdated.bind(this),
      );
  }

  // @ts-expect-error uspApi is currently not available in IE as it needs to be fixed
  private readTrackingConsents(): void {
    this.window.__uspapi &&
      this.window.__uspapi(
        "getUSPData",
        this.USP_API_VERSION,
        this.consentsUpdated.bind(this),
      );
  }
}
